export interface Damageable {
  readonly health: number;
  readonly isDestroyed: boolean;
  takeDamage(amount: number): void;
}

/** Health pool for the player and for drones. */
export class Health implements Damageable {
  private current: number;
  private destroyed = false;

  constructor(private readonly max: number) {
    this.current = max;
  }

  get health(): number {
    return this.current;
  }

  get isDestroyed(): boolean {
    return this.destroyed;
  }

  takeDamage(amount: number): void {
    if (this.destroyed || amount <= 0) return;
    this.current = Math.max(0, this.current - amount);
    if (this.current === 0) this.destroyed = true;
  }

  heal(amount: number): void {
    if (this.destroyed) return;
    this.current = Math.min(this.max, this.current + amount);
  }

  reset(): void {
    this.current = this.max;
    this.destroyed = false;
  }
}
